module.exports = __webpack_public_path__ + "img/icon_close_white.57d1ef08.png";